import { Component, Input } from '@angular/core';
import { TimelineMetadata, UwTimelineEvent } from './uw-timeline.model';
import { NgStyle, NgClass } from '@angular/common';
import { StatusIndicatorComponent } from '../status-indicator/status-indicator.component';
import { MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent } from '@angular/material/card';
import { NoRecordContainerComponent } from '../no-record-container/no-record-container.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'uw-timeline',
    templateUrl: './uw-timeline.component.html',
    styleUrls: ['./uw-timeline.component.scss'],
    imports: [NgStyle, StatusIndicatorComponent, MatCard, NgClass, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent, NoRecordContainerComponent, TranslateModule]
})
export class UwTimelineComponent {

  @Input()
  noDataMessage: string = 'messages.no_data_found';

  @Input()
  bgColor!: string;

  @Input()
  title!: string;

  @Input()
  events!: UwTimelineEvent[] | null;

  @Input()
  timelineMetadata!: TimelineMetadata | null;

  constructor() {}

  ngOnInit(): void {
  }

}
